import React from 'react'
import { DepartmentData } from './DepartmentData'
import { useParams } from 'react-router-dom'
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

const DepartmentDetailPage = () => {
 const {departmentCode} = useParams();
  const empDetail = DepartmentData.find((emp)=>emp.departmentCode===departmentCode)
  console.log(empDetail)
   const breadcrumbItems = [{ title: "Back To Department List", link: "/department" }];
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Department"
          title="Department Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <Card
        className=" p-4 shadow-sm border-0 w-100"
        style={{ backgroundColor: "#f9f9f9" }}
      >
        <Row className="mb-4">
      
          <Col lg={12} className="d-none d-lg-block">
            <div
              className="vr"
              style={{ height: "100%", backgroundColor: "#ccc" }}
            />
          </Col>

          <Col lg={7} xs={12}>
            {/* <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
                    {userData?.username}
                  </h6> */}

            {/* <hr /> */}
            <h6 className="fs-4 fw-bold mb-2" style={{ color: "#333" }}>
              {empDetail?.departmentName}
            </h6>
            <hr />
            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-envelope me-2"></i>
              {/* Email: {userData?.email} */}
              Department Code: {empDetail?.departmentCode || "N/A"}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-envelope me-2"></i>
              {/* Email: {userData?.email} */}
              Email: {empDetail?.email || "N/A"}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Phone Number : {empDetail?.contactNumber || "Invalid number"}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Department Name : {empDetail?.departmentName || "Invalid number"}
            </h6>
             <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Head of Department : {empDetail?.headOfDepartment || "Invalid number"}
            </h6>
             <hr />
            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Total Employees: {empDetail?.totalEmployees || "Invalid number"}
            </h6>
             <hr />
            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Active Disputes : {empDetail?.activeDisputes || "Invalid number"}
            </h6>
            <hr />

            <h6 className="fs-6 fw-bold mb-1">
              <i className="fas fa-phone me-2"></i>
              Resolved Disputes : {empDetail?.resolvedDisputes || "Invalid number"}
            </h6>
            <hr />

          

          </Col>
        </Row>
      </Card>
      <Row>
        {/* Database Info */}
        <Col md={4}>
          <Card className="mb-4 shadow-sm">
            <CardBody>
              <h3 className="h4 mb-3">{empDetail?.fullName}</h3>
              <p className="text-muted">
                <strong>Email:</strong>{" "}
                {empDetail?.email || "No description available"}
              </p>
            </CardBody>
          </Card>
        </Col>

        {/* Tables Accordion */}
        <Col md={8}>
          <Card className="shadow-sm">
            <CardHeader className="border-0">
              <h5 className="mb-0">Phone Number:</h5>
            </CardHeader>
            <CardBody>
              <p>{empDetail?.contactNumber}</p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default DepartmentDetailPage
